define('ScrollReveal', [], function ScrollRevealModule() {
	'use strict';

	// Timing defaults — mirrored in SCSS via CSS custom properties (:root).
	var THRESHOLD = 0.15;
	var STAGGER_DELAY = 90;
	var HERO_DELAY = 100;
	var DURATION = 700;

	var REVEAL_SELECTORS = ['.scroll-reveal'];
	var MERCHZONE_ZONE_SELECTOR = '.tt-ext-merchzone';
	var MERCHZONE_ITEM_SELECTOR = '.tt-ext-merchzone-item';

	var SELECTOR = REVEAL_SELECTORS.join(', ');
	var WATCHING_ATTR = 'data-scroll-reveal-watching';
	var MERCHZONE_WATCHING_ATTR = 'data-sr-merchzone-watching';
	var MERCHZONE_VISIBLE_ATTR = 'data-sr-merchzone-visible';

	var observer = null;
	var merchzoneRetryDelays = [250, 750, 2000];
	var merchzoneRetriesScheduled = false;

	function prefersReducedMotion() {
		return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	}

	function revealMerchzoneItems(zone) {
		var items = zone.querySelectorAll(MERCHZONE_ITEM_SELECTOR);

		Array.prototype.forEach.call(items, function revealItem(item) {
			item.classList.add('is-visible');
			item.removeAttribute(WATCHING_ATTR);
		});

		zone.setAttribute(MERCHZONE_VISIBLE_ATTR, '');
	}

	function revealAll() {
		var elements = document.querySelectorAll(SELECTOR + ', ' + MERCHZONE_ITEM_SELECTOR);

		Array.prototype.forEach.call(elements, function revealElement(element) {
			element.classList.add('is-visible');
			element.removeAttribute(WATCHING_ATTR);
		});
	}

	function onIntersect(entries) {
		entries.forEach(function handleEntry(entry) {
			if (!entry.isIntersecting) {
				return;
			}

			entry.target.classList.add('is-visible');
			entry.target.removeAttribute(WATCHING_ATTR);
			observer.unobserve(entry.target);
		});
	}

	function onMerchzoneIntersect(entries, zoneObserver) {
		entries.forEach(function handleZoneEntry(entry) {
			if (!entry.isIntersecting) {
				return;
			}

			revealMerchzoneItems(entry.target);
			zoneObserver.unobserve(entry.target);
		});
	}

	function watchMerchzoneItems(zone) {
		if (typeof MutationObserver === 'undefined') {
			return;
		}

		var itemObserver = new MutationObserver(function onMerchzoneDomChange() {
			if (!zone.hasAttribute(MERCHZONE_VISIBLE_ATTR)) {
				return;
			}

			revealMerchzoneItems(zone);
		});

		itemObserver.observe(zone, {
			childList: true,
			subtree: true
		});
	}

	function observeMerchzone(zone) {
		if (zone.hasAttribute(MERCHZONE_WATCHING_ATTR)) {
			if (zone.hasAttribute(MERCHZONE_VISIBLE_ATTR)) {
				revealMerchzoneItems(zone);
			}

			return;
		}

		zone.setAttribute(MERCHZONE_WATCHING_ATTR, '');

		if (prefersReducedMotion() || typeof IntersectionObserver === 'undefined') {
			revealMerchzoneItems(zone);
			return;
		}

		var zoneObserver = new IntersectionObserver(function merchzoneIntersectHandler(entries) {
			onMerchzoneIntersect(entries, zoneObserver);
		}, {
			threshold: 0.05,
			rootMargin: '0px 0px -8% 0px'
		});

		zoneObserver.observe(zone);
		watchMerchzoneItems(zone);
	}

	function observeMerchzones() {
		var zones = document.querySelectorAll(MERCHZONE_ZONE_SELECTOR);

		Array.prototype.forEach.call(zones, observeMerchzone);
	}

	function scheduleMerchzoneRetries() {
		if (merchzoneRetriesScheduled) {
			return;
		}

		merchzoneRetriesScheduled = true;

		merchzoneRetryDelays.forEach(function scheduleRetry(delay) {
			setTimeout(observeMerchzones, delay);
		});
	}

	function getObserver() {
		if (!observer) {
			observer = new IntersectionObserver(onIntersect, {
				threshold: THRESHOLD
			});
		}

		return observer;
	}

	function observePendingElements() {
		var elements = document.querySelectorAll(SELECTOR + ':not(.is-visible):not(.sr-disabled)');

		Array.prototype.forEach.call(elements, function observeElement(element) {
			if (element.hasAttribute(WATCHING_ATTR)) {
				return;
			}

			element.setAttribute(WATCHING_ATTR, '');
			getObserver().observe(element);
		});
	}

	function init() {
		merchzoneRetriesScheduled = false;

		if (prefersReducedMotion()) {
			revealAll();
			observeMerchzones();
			return;
		}

		if (typeof IntersectionObserver === 'undefined') {
			revealAll();
			return;
		}

		observePendingElements();
		observeMerchzones();
		scheduleMerchzoneRetries();
	}

	return {
		init: init,
		REVEAL_SELECTORS: REVEAL_SELECTORS,
		MERCHZONE_ITEM_SELECTOR: MERCHZONE_ITEM_SELECTOR,
		MERCHZONE_ZONE_SELECTOR: MERCHZONE_ZONE_SELECTOR,
		THRESHOLD: THRESHOLD,
		STAGGER_DELAY: STAGGER_DELAY,
		HERO_DELAY: HERO_DELAY,
		DURATION: DURATION
	};
});
